import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const SelfieCapture = ({
  onBack,
  onNext
}) => {
  const [capturing, setCapturing] = useState(true);
  const [captured, setCaptured] = useState(false);
  useEffect(() => {
    // Simulate capture process
    if (capturing) {
      const timer = setTimeout(() => {
        setCapturing(false);
        setCaptured(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [capturing]);
  return <div className="flex flex-col p-6 flex-grow bg-white" data-id="element-462">
      <div className="flex items-center mb-6" data-id="element-463">
        <button onClick={onBack} className="mr-4" data-id="element-464">
          <ChevronLeftIcon size={24} data-id="element-465" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-466">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-467"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-468"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-469"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-470"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-2 text-center" data-id="element-471">
        Let's take a selfie
      </h1>
      <p className="text-gray-700 mb-8 text-center" data-id="element-472">
        Keep a neutral expression, find balanced light and remove any glasses
        and hats
      </p>
      <div className="flex justify-center mb-10" data-id="element-473">
        <div className="relative w-64 h-64 rounded-full" data-id="element-474">
          <div className="absolute inset-0 rounded-full overflow-hidden" data-id="element-475">
            {capturing ? <div className="absolute inset-0 flex items-center justify-center bg-gray-200" data-id="element-476">
                <div className="w-12 h-12 border-t-2 border-[#5c5cf5] rounded-full animate-spin" data-id="element-477"></div>
              </div> : <div className="w-full h-full bg-gray-100 flex items-center justify-center" data-id="element-478">
                <div className="relative w-3/4 h-3/4" data-id="element-479">
                  {/* Head shape */}
                  <div className="absolute w-full h-3/4 bg-[#e0e0e0] rounded-full top-0" data-id="element-480"></div>
                  {/* Neck */}
                  <div className="absolute w-1/3 h-1/4 bg-[#e0e0e0] bottom-0 left-1/3" data-id="element-481"></div>
                  {/* Eyes */}
                  <div className="absolute w-2 h-2 bg-[#4040f2] rounded-full" style={{
                top: '40%',
                left: '30%'
              }} data-id="element-482"></div>
                  <div className="absolute w-2 h-2 bg-[#4040f2] rounded-full" style={{
                top: '40%',
                left: '70%'
              }} data-id="element-483"></div>
                  {/* Mouth */}
                  <div className="absolute w-1/3 h-1 bg-[#4040f2] rounded-full" style={{
                top: '60%',
                left: '33%'
              }} data-id="element-484"></div>
                </div>
              </div>}
          </div>
          <div className="absolute inset-0 border-4 border-dashed border-[#4040f2] rounded-full animate-pulse" data-id="element-485"></div>
        </div>
      </div>
      <div className="mt-auto" data-id="element-486">
        <button className={`w-full py-3 rounded-full font-medium text-white ${captured ? 'bg-[#4040f2]' : 'bg-gray-300'}`} onClick={onNext} disabled={!captured} data-id="element-487">
          CONTINUE
        </button>
      </div>
    </div>;
};